<template>
  <div id="app" v-if="tokenAlive" :class="{'only-show-content':onlyShowContent}">
    <router-view v-if="isRouterAlive" />
  </div>
</template>
<script>
import { getGsmInfo,getPpuserInfo,menuTreeList } from "./api/login";
import { isOutIn } from "./utils/index.js";
export default {
  name: "App",
  provide() {
    return {
      reload: this.reload,
    };
  },
  data() {
    return {
      isRouterAlive: true, 
      tokenAlive:true,
      onlyShowContent:false
    };
  },
  methods: {
    reload() {
      this.isRouterAlive = false; 
      this.$nextTick(function () {
        this.isRouterAlive = true; 
      });
    },
    // 初始化菜单数据（仅从接口，不写 localStorage）
    async initMenuData() {
      try {
        const { getMenuInfo } = await import('@/api/common.js');
        const res = await getMenuInfo();
        if (res.data && res.data.rows) {
          this.$store.commit("SET_MENUDATA", res.data.rows);
        }
      } catch (error) {
        console.error('初始化菜单数据失败:', error);
      }
    },
  },
  mounted() {
    if (isOutIn()){
      this.$nextTick(()=>{
        document.body.classList.add('only-show-body')
        document.documentElement.classList.add('only-show-body')
      })
    }
    // 移除重复的菜单数据初始化，由permission.js统一处理
  },
  created () {
    this.tokenAlive = false
    //pp gsm  携带token跳转自动登录
    if(decodeURIComponent(window.location.search).indexOf('token')!==-1){
    var token,type,data,jform
    var url = decodeURIComponent(window.location.search)
    if(decodeURIComponent(window.location.href).indexOf('home')!==-1){
      if(url.indexOf('jform')!==-1){
        data=JSON.parse(url.split('?')[1].split('&')[0].split('=')[1])
        token = url.split('?')[1].split('&')[1].split('=')[1]
        jform=url.split('?')[1].split('&')[2].split('=')[1]
        type=1
        console.log(jform);
      }else{
        token = url.split('?')[1].split('=')[1]
        type = url.split('?')[2]//1:gsm  2:pp
      }
    }else  if(decodeURIComponent(window.location.href).indexOf('indexPage')!==-1){
      token = url.split('?')[2].split('=')[1]
      type = url.split('?')[3]//1:gsm  2:pp
      var menuid = url.split('?')[1].split('=')[1]
    }
      localStorage.setItem("library_token", token);
      localStorage.setItem("loginFailTime", 0);
      localStorage.setItem("readPrivacyPolicy", 0);
      if(type==1){
        getGsmInfo().then((res) => {
        localStorage.setItem("library_userInfo",JSON.stringify(res.data.user));
        this.$store.commit("SET_USERINFO", res.data.user);
        this.$router.push({path:`/home`})
        if(jform=='sp'){
          this.$router.push({
            path: "/detailPage",
            query: { articleData: JSON.stringify(data) },
          });
        }
        this.tokenAlive = true
      });
      }
      else if(type==2){
        getPpuserInfo().then(res=>{
        localStorage.setItem('library_userInfo',JSON.stringify(res.data.user))
        this.$store.commit('SET_USERINFO',res.data.user)
        menuTreeList(menuid).then(res=>{
          console.log(res.data.rows[0]);
          localStorage.setItem('library_tree',JSON.stringify(res.data.rows[0]))
          console.log(window.location.href);
          this.$router.push({name:`indexPage`,params:{detailId:menuid},query:{module:menuid}})
          this.tokenAlive = true
        })
      })
      }    
    }else{
      this.tokenAlive = true
    }
    
  },
  watch: {
    $route(to,from){
      this.$nextTick(()=>{
        console.log(this.$route.query, "【----】监听路由的变化++++");
        const { view_mode } = this.$route.query
        this.onlyShowContent = false
        if ((this.$route.path.includes('/indexPage') || this.$route.path.includes('/detailPage')) && view_mode == '2') {
          // 添加样式
          this.onlyShowContent = true
        }
      })
    }
  }
};
</script>

<style lang="scss">
#app {
  width: 100%;
  height: 100%;
  overflow-x: hidden;
}
</style>
